"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class Loader {
    constructor(handle) {
        this.cache = new Map();
        this.data = new Map();
        this.handle = handle;
    }
    _handle(key) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.handle(key)
                .then((result) => {
                this.data.set(key, result);
                return result;
            })
                .catch((err) => {
                this.cache.delete(key);
                throw err;
            });
        });
    }
    load(key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.has(key)) {
                this.cache.set(key, this._handle(key));
            }
            return this.cache.get(key);
        });
    }
    isLoading(key) {
        return this.cache.has(key) && !this.data.has(key);
    }
    get size() {
        return this.data.size;
    }
    set(key, value) {
        this.cache.set(key, Promise.resolve(value));
        this.data.set(key, value);
    }
    clear(key) {
        this.data.delete(key);
        return this.cache.delete(key);
    }
    clearAll() {
        if (this.cache.size > 0) {
            this.cache = new Map();
            this.data = new Map();
            return true;
        }
        else {
            return false;
        }
    }
}
exports.default = Loader;
